import {
  Breadcrumb,
  Button,
  Card,
  DatePicker,
  Divider,
  Form,
  Input,
  Modal,
  Select,
} from "antd";
import React, { useState, useCallback, useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { ReactComponent as HomeIcon } from "../../assests/images/home-line.svg";
import {
  allowDecimalwithMaxLimit,
  allowOnlyAlphaNumericsWithSpace,
  allowOnlyNumbers,
  allowOnlyAlphaNumericsShouldNotStartWithSpace,
  amountFormat,
} from "../../services/common.service";
import { NumericFormat, PatternFormat } from "react-number-format";
import { useSelector } from "react-redux";
import {
  accountListSelector,
  modeSelector,
} from "../../store/selectors/app.selector";
import SendMoneyService from "../../services/send-money.service";
import moment from "moment";
import RemarkTags from "../../components/remarkTags";
import TransferService from "../../services/transfer.service";
import CommonOtp from "../../components/otp";
import successIcon from "../../assests/images/thumb_up.gif";
import { AiOutlineLeft } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import FEATURE_CONFIG from "client/feature.config.json";

export default function ModifyPaymentScheduledTrnsComponent() {
  const navigate = useNavigate();
  const [stage, setStage] = useState(1);
  const [form] = Form.useForm();
  const [remarksTagList, setRemarksTagList] = useState([]);
  const [balance, setBalance] = useState(0);
  const accountList = useSelector(accountListSelector);
  const location = useLocation();
  const [remarkTag, setRemarkTag] = useState({});
  const [loader, setLoader] = useState(false);
  const [cancelVisible, setCancelVisible] = useState(false);
  const [scheduleDetails, setScheduleDetails] = useState({});
  const [formValues, setFormValues] = useState({});
  const [respDetails, setRespDetails] = useState({});
  const { t } = useTranslation();
  const [metaData, setMetaData] = useState({
    frequency: [],
    maximumInstallments: [],
    paymentTypes: {},
    transferTypes: {},
    rtgsAmount: 1,
    rtgsMaxAmount: 1,
    rtgsMinAmount: 1,
    neftAmount: 1,
    neftMaxAmount: 1,
    neftMinAmount: 1,
  });
  const [otp, setOtp] = useState("");
  const mode = useSelector(modeSelector);
  const transferTypes = {
    NEFT: "NEFT(24X7) 30 min+",
    IMPS: "IMPS Instant",
    RTGS: "RTGS(24X7) Instant",
    IAT: t("pages.sendMoney.common_sendMoney.within_bank", {
      defaultValue: "Within Bank",
    }),
    OAT: t("pages.sendMoney.common_sendMoney.within_bank", {
      defaultValue: "Within Bank",
    }),
    ...(FEATURE_CONFIG.ADD.DOMESTIC_BENE && { ABC: "ABC" }),
  };

  useEffect(() => {
    if (location.state) {
      setScheduleDetails(location.state);
      //   console.log(new Date(location.state.scheduledDate));
      //   console.log(
      //     moment(moment(location.state.scheduledDate).format("MM/DD/YYYY"))
      //   );
      form.setFieldsValue({
        amount: location.state.amount,
        numberOfInstallments: location.state.pendingInstallments,
        frequency: location.state.frequency,
        transferType: location.state.transferType,
        paymentType: location.state.paymentType,
        srcAccountNo: location.state.srcAccountNo,
        payeeName: `${location.state.payeeName} - ${location.state.destAccount}`,
        // scheduledDate: null // moment(moment(location.state.scheduledDate).format("MM/DD/YYYY")),
      });

      const currentBalance = accountList?.find(
        (ele) => ele.acctNo === location?.state?.srcAccountNo
      );
      setBalance(currentBalance?.effectiveAvailableBalance);
    }
    transferOptions();
  }, [accountList]);

  const onVerify = useCallback(
    async (values) => {
      try {
        const transferAmount =
          typeof values.amount === "number"
            ? values.amount
            : parseFloat(values.amount.replaceAll(/,/g, ""));

        const reqParams = {
          actionType: "M",
          amount: transferAmount,
          frequency: values.frequency,
          numberOfInstallments: values.numberOfInstallments,
          remarks: values.remarks,
          remarksTag: remarkTag?.value || "",
          scheduledDate: values.scheduledDate,
          scheduledId: scheduleDetails?.id,
        };
        setFormValues(reqParams);
        setStage(2);
      } catch (error) {
        setLoader(false);
      }
    },
    [scheduleDetails, remarkTag]
  );

  const modifyOrCancelScheduledTransferVerify = useCallback(async () => {
    try {
      setLoader(true);
      const response =
        await TransferService.modifyOrCancelScheduledTransferVerify(formValues);
      if (response.status === 200) {
        setLoader(false);
        setStage(3);
      }
    } catch (error) {}
  }, [formValues]);

  const onConfirm = useCallback(
    async (values) => {
      try {
        setLoader(true);
        const response =
          await TransferService.modifyOrCancelScheduledTransferConfirm(values);
        if (response.status === 200) {
          setLoader(false);
          setRespDetails(response.data);
          setStage(4);
        }
      } catch (error) {
        setOtp("");
      }
    },
    [scheduleDetails, remarkTag]
  );

  const handleAccChange = useCallback(
    (value) => {
      const selectedAccDetails = accountList.find(
        (ele) => ele.acctNo === value
      );
      setBalance(selectedAccDetails?.effectiveAvailableBalance || 0);
    },
    [accountList]
  );

  const transferOptions = useCallback(async () => {
    try {
      const response = await SendMoneyService.transferOptions();
      if (response.status === 200) {
        setMetaData(response.data);
      }
    } catch (error) {}
  }, []);

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm();

      case 2:
        return renderConfirm();

      case 3:
        return (
          <div className="col-12">
            <Card>
              <div className="col-7">
                <CommonOtp
                  otp={otp}
                  setOtp={setOtp}
                  type="TRANSACTION"
                  onConfirm={(values) =>
                    onConfirm({
                      ...formValues,
                      ...values,
                    })
                  }
                  handleResendOtp={() => onVerify(formValues)}
                  cancelTransaction={() => {
                    setStage(1);
                  }}
                />
              </div>
            </Card>
          </div>
        );

      case 4:
        return renderSuccess();

      default:
        return renderForm();
    }
  }

  function renderForm() {
    return (
      <>
        <Form
          layout="vertical"
          onFinish={onVerify}
          requiredMark={true}
          initialValues={formValues}
          form={form}
        >
          <div className="row">
            <div className="col-3">
              Payee{" "}
              <span style={{ color: "red" }}>
                <span style={{ color: "red" }}>*</span>
              </span>
            </div>
            <div className="col-5">
              <Form.Item
                label=""
                name={"payeeName"}
                rules={[{ required: true, message: "payee is required" }]}
              >
                <Input
                  style={{ pointerEvents: "none" }}
                  placeholder="Payee"
                  size="middle"
                />
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-3">
              Pay From<span style={{ color: "red" }}>*</span>
            </div>
            <div className="col-5" style={{ position: "relative" }}>
              <Form.Item
                name={"srcAccountNo"}
                rules={[{ required: true, message: "Pay From is required" }]}
              >
                <Select
                  style={{ pointerEvents: "none" }}
                  placeholder="Pay From"
                  bordered={true}
                  optionLabelProp={"value"}
                >
                  {accountList.map((option, idx) => (
                    <Select.Option key={idx} value={option.acctNo}>
                      <span className="acc-short-name">
                        {option?.acctShortName}
                      </span>
                      <br />
                      <span style={{ fontSize: "12px" }}>{option?.acctNo}</span>
                      <br />
                      <span style={{ fontSize: "12px" }}>
                        {option?.acctBranchDesc}
                      </span>
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <span
                className="acc-balance"
                style={{ position: "absolute", right: "15px", bottom: 0 }}
              >
                {t("common.avl_bal", {
                  defaultValue: "Avl Bal",
                })}
                : {amountFormat(balance)}
              </span>
            </div>
          </div>

          <div className="row">
            <div className="col-3">
              Amount<span style={{ color: "red" }}>*</span>
            </div>
            <div className="col-3">
              <Form.Item
                label=""
                name={"amount"}
                rules={[
                  {
                    required: true,
                    message: t("errorMesssages.amount_required", {
                      defaultValue: "Amount is required",
                    }),
                  },
                  {
                    validator: (_, value) => {
                      if (parseFloat(value) <= 0) {
                        return Promise.reject(
                          t("errorMesssages.amount_valid", {
                            defaultValue: "Amount should be greater than 0",
                          })
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <NumericFormat
                  type="tel"
                  placeholder="Amount"
                  maxLength={12}
                  allowNegative={false}
                  customInput={Input}
                  thousandSeparator={true}
                  fixedDecimalScale={false}
                  addonBefore="₹"
                  onKeyPress={(e) => allowDecimalwithMaxLimit(e)}
                />
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-3">
              Send Via{" "}
              <span style={{ color: "red" }}>
                <span style={{ color: "red" }}>*</span>
              </span>
            </div>
            <div className="col-3">
              <Form.Item
                label=""
                name={"transferType"}
                rules={[{ required: true, message: "Send Via is required" }]}
              >
                <Select
                  style={{ pointerEvents: "none" }}
                  placeholder="Send Via"
                  bordered={true}
                >
                  <Select.Option value="IMPS">IMPS Instant</Select.Option>
                  <Select.Option value="IAT">
                    {t("pages.sendMoney.common_sendMoney.within_bank", {
                      defaultValue: "Within Bank",
                    })}
                  </Select.Option>
                  <Select.Option value="OAT">
                    {t("pages.sendMoney.common_sendMoney.within_bank", {
                      defaultValue: "Within Bank",
                    })}
                  </Select.Option>
                  <Select.Option value="RTGS">RTGS(24X7) Instant</Select.Option>
                  <Select.Option value="NEFT">NEFT(24X7) 30 min+</Select.Option>
                </Select>
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-3">
              {t("pages.view_scheduled_transfer.payment_type", {
                defaultValue: "Payment Type",
              })}{" "}
              <span style={{ color: "red" }}>
                <span style={{ color: "red" }}>*</span>
              </span>
            </div>
            <div className="col-3">
              <Form.Item
                label=""
                name={"paymentType"}
                rules={[
                  { required: true, message: "Payment Type is required" },
                ]}
              >
                <Select
                  style={{ pointerEvents: "none" }}
                  placeholder={t("pages.view_scheduled_transfer.payment_type", {
                    defaultValue: "Payment Type",
                  })}
                  bordered={true}
                >
                  <Select.Option value="ONCE">One Time</Select.Option>
                  <Select.Option value="RECURRING">Recurring SI</Select.Option>
                  <Select.Option value="SCHEDULED">
                    One Time -Scheduled
                  </Select.Option>
                </Select>
              </Form.Item>
            </div>
          </div>

          {scheduleDetails?.paymentType === "RECURRING" && (
            <div className="row">
              <div className="col-3">
                Number of Installment{" "}
                <span style={{ color: "red" }}>
                  <span style={{ color: "red" }}>*</span>
                </span>
              </div>
              <div className="col-3">
                <Form.Item
                  label=""
                  name={"numberOfInstallments"}
                  rules={[
                    {
                      required: true,
                      message: "Number of installment is required",
                    },
                  ]}
                >
                  <Select placeholder="Number of installment" bordered={true}>
                    {metaData.maximumInstallments.map((option, idx) => (
                      <Select.Option key={idx} value={option}>
                        {option}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
            </div>
          )}

          {scheduleDetails?.paymentType === "RECURRING" && (
            <div className="row">
              <div className="col-3">
                {t("pages.fundtransfer.frequency", {
                  defaultValue: "Frequency",
                })}
                <span style={{ color: "red" }}>*</span>
              </div>
              <div className="col-3">
                <Form.Item
                  label=""
                  name={"frequency"}
                  rules={[{ required: true, message: "Frequency is required" }]}
                >
                  <Select
                    placeholder={t("pages.fundtransfer.frequency", {
                      defaultValue: "Frequency",
                    })}
                    bordered={true}
                  >
                    {metaData.frequency.map((option, idx) => (
                      <Select.Option key={idx} value={option}>
                        {option}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
            </div>
          )}

          <div className="row">
            <div className="col-3">
              Date<span style={{ color: "red" }}>*</span>
            </div>
            <div className="col-5">
              <Form.Item
                label=""
                name={"scheduledDate"}
                style={{ width: "100%" }}
                rules={[
                  {
                    required: true,
                    message: t("errorMesssages.date_require", {
                      defaultValue: "Date is required",
                    }),
                  },
                ]}
              >
                <DatePicker
                  disabledDate={(current) =>
                    current.isBefore(moment().subtract(1, "days"))
                  }
                  placeholder="MM/DD/YYYY"
                  // format={"MM/DD/YYYY"}
                  format={{
                    format: "DD-MM-YYYY",
                    type: "mask",
                  }}
                />
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-3">
              {" "}
              {t("common.remarks", { defaultValue: "Reason" })}
              <span style={{ color: "red" }}>*</span>
            </div>
            <div className="col-5">
              <Form.Item
                label=""
                name={"remarks"}
                rules={[
                  {
                    required: true,
                    message: t("errorMesssages.remark_require", {
                      defaultValue: "Reason is required",
                    }),
                  },
                ]}
              >
                <Input
                  onKeyPress={(e) => allowOnlyAlphaNumericsShouldNotStartWithSpace(e)}
                  placeholder={t("common.remarks", { defaultValue: "Reason" })}
                  size="middle"
                  maxLength={30}
                />
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-3"></div>
            <div className="col-6">
              <RemarkTags
                setSelected={setRemarkTag}
                setRemarksTagList={setRemarksTagList}
                remarksTagList={remarksTagList}
              />
            </div>
          </div>

          <div className="d-flex justify-content-end  mt-3">
            <Button
              onClick={() => navigate("/send-money/history/scheduled")}
              type="default"
              style={{ marginRight: 20 }}
            >
              {t("buttons.cancel_btn", {
                defaultValue: "Cancel",
              })}
            </Button>
            <Button loading={loader} type="primary" htmlType="submit">
              {t("buttons.submit_btn", {
                defaultValue: "Submit",
              })}{" "}
            </Button>
          </div>
        </Form>
      </>
    );
  }

  function renderConfirm() {
    return (
      <>
        <p className="mb-4">
          {t("pages.sendMoney.payee.payment_txt", {
            defaultValue:
              "Please check the payment details carefully, before you proceed",
          })}
        </p>
        <div className="confirm-details">
          <div className="row">
            <div className="col-3 mb-3 ">
              <label>
                {" "}
                {t("common.source_acc_no", {
                  defaultValue: "Source Account Number",
                })}
              </label>
              <span>{scheduleDetails?.srcAccountNo}</span>
            </div>
            <div className="col-3 mb-3 ">
              <label>
                {" "}
                {t("pages.standing_instruction.dest_acc_no", {
                  defaultValue: "Destination Account Number",
                })}
              </label>
              <span>{scheduleDetails?.srcAccountNo}</span>
            </div>
            <div className="col-3 mb-3 ">
              <label>{t("common.amount", { defaultValue: "Amount" })}</label>
              <span>{amountFormat(formValues?.amount)}</span>
            </div>
            <div className="col-3 mb-3 ">
              <label>
                {t("pages.view_scheduled_transfer.payment_type", {
                  defaultValue: "Payment Type",
                })}
              </label>
              <span>
                {" "}
                {metaData.paymentTypes[scheduleDetails?.paymentType]}
              </span>
            </div>
            {scheduleDetails?.paymentType === "RECURRING" && (
              <div className="col-3 mb-3 ">
                <label>Number of Installment</label>
                <span>{formValues?.numberOfInstallments}</span>
              </div>
            )}

            {scheduleDetails?.paymentType === "RECURRING" && (
              <div className="col-3 mb-3 ">
                <label>
                  {t("pages.fundtransfer.frequency", {
                    defaultValue: "Frequency",
                  })}
                </label>
                <span>{formValues?.frequency}</span>
              </div>
            )}

            <div className="col-3 mb-3 ">
              <label>Date</label>
              <span>
                {moment(formValues?.scheduledDate?.$d).format("DD-MM-YYYY") ||
                  "-"}
              </span>
            </div>
            <div className="col-3 mb-3 ">
              <label>Send Via</label>
              <span> {transferTypes[scheduleDetails?.transferType]}</span>
            </div>
            <div className="col-3 mb-3 ">
              <label>{t("common.remarks", { defaultValue: "Reason" })}</label>
              <span>{formValues?.remarks}</span>
            </div>

            {Object.keys(remarkTag).length > 0 && (
              <div className="col-3 mb-3 ">
                <label>Remarks Tag</label>
                <span>
                  <img
                    src={remarkTag?.iconSelected}
                    height={20}
                    width={20}
                    alt="icon"
                    style={{ marginRight: 5 }}
                  />{" "}
                  {remarkTag?.label}
                </span>
              </div>
            )}
          </div>
        </div>

        <div className="d-flex justify-content-start mt-5">
          {/* <Button
            onClick={() => setCancelVisible(true)}
            type="default"
            style={{ marginRight: 30 }}
          >
            Cancel
          </Button> */}

          <Button
            onClick={() => setStage(1)}
            type="default"
            style={{ marginRight: 30 }}
          >
            {t("buttons.back_btn", {
              defaultValue: "Back",
            })}
          </Button>
          <Button
            onClick={() => modifyOrCancelScheduledTransferVerify()}
            loading={loader}
            type="primary"
          >
            {t("buttons.proceed_btn", {
              defaultValue: "Proceed",
            })}
          </Button>
        </div>
      </>
    );
  }

  function renderSuccess() {
    return (
      <div className="row d-flex justify-content-center">
        <div className="col-10 ">
          <div className="row">
            <div className="col-6">
              <img height={250} src={successIcon} alt="Success" />

              <p style={{ fontSize: 15, marginBottom: 30 }}>
                {respDetails.message}
              </p>
              <div>
                <Button
                  onClick={() => {
                    navigate("/send-money/history/scheduled");
                  }}
                >
                  Back to Home
                </Button>
              </div>
            </div>
            <div className="col-6">
              <div>
                <span className="lbl-receipt">
                  {" "}
                  {t("pages.gepeg.source_account", {
                    defaultValue: "Source Account",
                  })}
                  :
                </span>
                <p className="value-receipt">
                  xxxxxxxxxxx
                  {respDetails?.srcAccountNo?.slice(
                    respDetails?.srcAccountNo?.length - 4,
                    respDetails?.srcAccountNo?.length
                  )}
                  , {respDetails?.srcAcctBankName},{" "}
                  {respDetails?.srcAccountBranchName}
                </p>
              </div>

              <Divider type="horizontal" style={{ margin: "5px 0" }} />

              <div>
                <span className="lbl-receipt">
                  {t("common.destination_account", {
                    defaultValue: "Destination Account",
                  })}
                  :
                </span>
                <p className="value-receipt">
                  {respDetails?.destAccountNo}, {respDetails?.destAcctBankName},{" "}
                  {respDetails?.destAccountBranchName}
                </p>
              </div>
              <Divider type="horizontal" style={{ margin: "5px 0" }} />

              <div className="row">
                <div className="col-5 lbl-receipt">Amount </div>
                <div className="col-7 value-receipt">
                  : {amountFormat(respDetails?.amount)}
                </div>
              </div>
              <Divider type="horizontal" style={{ margin: "5px 0" }} />

              <div className="row">
                <div className="col-5 lbl-receipt">
                  {t("pages.view_scheduled_transfer.payment_type", {
                    defaultValue: "Payment Type",
                  })}{" "}
                </div>
                <div className="col-7 value-receipt">
                  : {metaData.paymentTypes[scheduleDetails?.paymentType]}
                </div>
              </div>
              {scheduleDetails?.paymentType === "RECURRING" && (
                <>
                  <Divider type="horizontal" style={{ margin: "5px 0" }} />

                  <div className="row">
                    <div className="col-5 lbl-receipt">
                      {t("pages.sendMoney.payee.number_of_installments", {
                        defaultValue: "Number Of Installments",
                      })}{" "}
                    </div>
                    <div className="col-7 value-receipt">
                      : {formValues?.numberOfInstallments || "-"}
                    </div>
                  </div>
                </>
              )}

              {scheduleDetails?.paymentType === "RECURRING" && (
                <>
                  <Divider type="horizontal" style={{ margin: "5px 0" }} />

                  <div className="row">
                    <div className="col-5 lbl-receipt">
                      {t("pages.fundtransfer.frequency", {
                        defaultValue: "Frequency",
                      })}{" "}
                    </div>
                    <div className="col-7 value-receipt">
                      : {formValues?.frequency}
                    </div>
                  </div>
                </>
              )}

              <Divider type="horizontal" style={{ margin: "5px 0" }} />

              <div className="row">
                <div className="col-5 lbl-receipt">
                  {t("common.remarks", { defaultValue: "Reason" })}{" "}
                </div>
                <div className="col-7 value-receipt">
                  : {respDetails.remarks}
                </div>
              </div>
              <Divider type="horizontal" style={{ margin: "5px 0" }} />

              {Object.keys(remarkTag).length > 0 && (
                <>
                  <div className="row">
                    <div className="col-5 lbl-receipt">Remarks Tag </div>
                    <div className="col-7 value-receipt">
                      :{" "}
                      <span>
                        <img
                          src={remarkTag?.iconSelected}
                          height={20}
                          width={20}
                          alt="icon"
                          style={{ marginRight: 2 }}
                        />{" "}
                        {remarkTag?.label}
                      </span>
                    </div>
                  </div>
                  <Divider type="horizontal" style={{ margin: "5px 0" }} />
                </>
              )}

              <Divider type="horizontal" style={{ margin: "5px 0" }} />

              <div className="row">
                <div className="col-5 lbl-receipt">
                  {t("common.created_date", { defaultValue: "Created Date" })}
                </div>
                <div className="col-7 value-receipt">
                  : {moment().format("DD-MM-YYYY")}
                </div>
              </div>
              <Divider type="horizontal" style={{ margin: "5px 0" }} />

              <div className="row">
                <div className="col-5 lbl-receipt">
                  {t("common.scheduled_date", {
                    defaultValue: "Scheduled Date",
                  })}{" "}
                </div>
                <div className="col-7 value-receipt">
                  : {moment(formValues?.scheduledDate?.$d).format("DD-MM-YYYY")}
                </div>
              </div>
              <Divider type="horizontal" style={{ margin: "5px 0" }} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div
        style={{ marginBottom: 20 }}
        className="d-flex align-items-center justify-content-between"
      >
        <Breadcrumb>
          {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item> */}
          <Breadcrumb.Item>
            <span onClick={() => navigate("/send-money")}>Send Money</span>
          </Breadcrumb.Item>

          <Breadcrumb.Item>
            <span onClick={() => navigate("/send-money/history")}>
              {t("buttons.payment_history_btn", {
                defaultValue: "Payment History",
              })}
            </span>
          </Breadcrumb.Item>

          <Breadcrumb.Item>
            <span onClick={() => navigate("/send-money/history/scheduled")}>
              {t("buttons.view_scheduled_transactions_btn", {
                defaultValue: "View Scheduled Transactions",
              })}
            </span>
          </Breadcrumb.Item>

          <Breadcrumb.Item>
            <span>Modify Schedule Payment</span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <div className="row">
        <div className="col-10">
          <h3 className="primary-title">Modify Schedule Payment</h3>
          <Card style={{ padding: "10px 50px" }} className="application-card">
            {renderSwitch()}
          </Card>
        </div>
      </div>

      <Modal
        title={t("errorMesssages.error", { defaultValue: "Error" })}
        open={cancelVisible}
        footer={null}
        width={350}
        closable={false}
        maskClosable={false}
        mask={true}
      >
        <p style={{ marginBottom: 30, fontSize: 15 }}>
          If you cancel this transaction now, you will have to start over. Are
          you sure you want to cancel?
        </p>
        <div className="mt-3" align="right">
          <Button type="default" onClick={() => setCancelVisible(false)}>
            {t("buttons.no_btn", {
              defaultValue: "No",
            })}
          </Button>
          <Button
            type="primary"
            style={{ marginLeft: 20 }}
            onClick={() => {
              setCancelVisible(false);
              navigate("/send-money");
            }}
          >
            {t("buttons.yes_btn", {
              defaultValue: "Yes",
            })}
          </Button>
        </div>
      </Modal>
    </>
  );
}
